import AssignmentsHistory from './AssignmentsHistory'

export { default as AssignmentsHistory } from './AssignmentsHistory'
export default AssignmentsHistory
